export default "__VITE_ASSET__CsFXxMpw__"